// Sentinel values for `course_card_id` that are NOT real digital course card
// references. Prefixed with `x_` so they are distinguishable from real card IDs.
//
// Canonical source: config/course_card_sentinels.yaml (shared with the Flutter
// app via lib/core/constants/course_card_sentinels.dart). Kept as a small JS
// mirror here because the committee build has no YAML loader — keep in sync.

export const SENTINEL_PREFIX = 'x_';

export const COURSE_CARD_SENTINELS = [
  { id: 'x_windward_leeward', label: 'Windward / Leeward' },
  { id: 'x_event_specific', label: 'Event-Specific Course' },
  { id: 'x_coming_soon', label: 'Coming Soon' },
  { id: 'x_preview_unavailable', label: 'Preview Unavailable' },
];

/** True when id is a sentinel rather than a real course card reference. */
export function isSentinel(id) {
  return typeof id === 'string' && id.startsWith(SENTINEL_PREFIX);
}

/** Human-readable label for a sentinel id, or null if not a known sentinel. */
export function sentinelLabel(id) {
  const s = COURSE_CARD_SENTINELS.find((x) => x.id === id);
  return s ? s.label : null;
}
